import React from 'react'

export default function NotificationBell() {
  return (

    <div className="wrapper__notification">
      <button className="wrapper__notify__btn">
        <img src="/svg/notify_icon.svg" alt="Notifications" className="img-fluid" />
      </button>
    </div>

  );
}
